<template>
    <div class="section-box project-payment">
        <el-row class="row-bg">
            <el-col :span="12" style="text-align: left;line-height: 36px;">
                <el-button size="mini" :class="form.tag ==1 ?'selected':''" @click="chose(1)">预计收款</el-button>
                <el-button size="mini" style="margin-left: 25px;" :class="form.tag ==2 ?'selected':''" @click="chose(2)">已收款</el-button>
                <el-button size="mini" style="margin-left: 25px;" :class="form.tag ==3 ?'selected':''" @click="chose(3)">已作废</el-button>
            </el-col>
            <el-col :span="12" style="text-align: right;">
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
                <el-button size="medium" type="primary" icon="el-icon-download" @click="downloadFile()">下载数据</el-button>
            </el-col>
        </el-row>

        <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="666"
            border
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <!-- <el-table-column label="款项编号">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.SerialNumber" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.SerialNumber || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column> -->
            <el-table-column label="工单号" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.jobNo" placeholder="输入关键字搜索" @blur="GetCouponsList()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.jobNo || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="工单名称" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.title" placeholder="输入关键字搜索" @blur="GetCouponsList()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.title || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发单方">
                <el-table-column show-overflow-tooltip width="180">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.sendUserName" placeholder="输入关键字搜索" @blur="GetCouponsList()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.sendUserName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发单Code" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.sendUserCode" placeholder="输入关键字搜索" @blur="GetCouponsList()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.sendUserCode || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="应收金额" >
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.amountBegin" style="width: 45%;" placeholder="搜索" type="number"/> ~
                        <el-input size="mini" v-model="form.amountEnd" style="width: 45%;" placeholder="搜索" @blur="GetCouponsList()" type="number"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.amount}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="款项名称" >
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.noteType" placeholder="请选择款项名称" style="width: 100%;" @change="GetCouponsList()">
                            <el-option value="" label="请选择"></el-option>
                            <el-option :value="item.key" :label="item.value" v-for="(item, index) in payMentNameOptionArr" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.payMentName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageNo"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
// DOTO：静态展示数据 对接的时候可以删掉
import { PERIOD } from '@/config/const/common.js'
// End
import { 
  getStorageToken,
} from '@/utils/store'
import {
    projectFundsList,payMentNameOption,
} from "@/service/payApi";
  export default {
    data() {
        return {
            PERIOD,
            listLoading: false,
            form: {
                PageNo: 1,
                PageSize: 10,

                Name: '',               //名称
                EffectivityTime: [],    //时间
                amountBegin:'',
                amountEnd:'',
                jobNo:'',
                noteType:'',
                sendUserCode:'',
                sendUserName:'',
                tag:1,
                title:'',
            },
            searchData:{},
            oraginForm:{},
            total: 0,                       //总条数
            tableData:[],
            payMentNameOptionArr:[],
        }
    },
    activated(){
        this.handleSearch()
        this.getPayMentNameOption()
    },
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.tableData = [];
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        getPayMentNameOption(){
                payMentNameOption().then((r)=>{
                    if(r.Result != 1){
                        return this.$message.error(r.Message)
                    }
                    this.payMentNameOptionArr = r.Data
                })
            },
        downloadFile() {
            let data = {
            }

            if(this.form.amountBegin) data.amountBegin = this.form.amountBegin
            if(this.form.amountEnd) data.amountEnd = this.form.amountEnd
            if(this.form.jobNo) data.jobNo = this.form.jobNo
            if(this.form.noteType) data.noteType = this.form.noteType
            if(this.form.sendUserCode) data.sendUserCode = this.form.sendUserCode
            if(this.form.sendUserName) data.sendUserName = this.form.sendUserName
            if(this.form.tag) data.tag = this.form.tag
            if(this.form.title) data.title = this.form.title

            let url =
            process.env.NODE_ENV == "development" ?
            "/api2" :
            process.env.VUE_APP_API2;

            window.open(
            url + "/gz/admin/download/projectFunds/download" + "?" + this.parseJsonURL(data)
            );
        },
        parseJsonURL(json) {
            if (!json) return "";
            if (typeof json == "string") return json;
            return this.cleanArray(
            Object.keys(json).map(function (key) {
                if (json[key] === undefined) return "";
                return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
            })
            ).join("&");
        },
        cleanArray(actual) {
        var newArray = [];
        for (var i = 0; i < actual.length; i++) {
          if (actual[i]) {
            newArray.push(actual[i]);
          }
        }
        return newArray;
      },
        chose(type){
            this.form.tag = type;this.form.PageNo=1;this.form.PageSize=10
            this.GetCouponsList()
        },
        //渲染列表
        handleSearch() {
            this.searchData = Object.assign({}, this.form)
            this.GetCouponsList()
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.PageNo = val
            this.searchData.PageNo = val
            this.GetCouponsList()
        },
        //翻页
        handleSizeChange(val) {
        if (this.listLoading) return
            this.form.PageNo = 1
            this.form.PageSize = val
            this.searchData.PageNo = 1
            this.searchData.PageSize = val
            this.GetCouponsList()
        },
        // TODO：修改接口名 form参数 table展示数据 -> 款项名称select
        async GetCouponsList(){
            this.listLoading = true
            let data = {
                pageNum:this.form.PageNo,
                pageSize:this.form.PageSize,   
                rational:true,
            }
            data.Token = getStorageToken();
            data.platform = 'zyd'

            if(this.form.amountBegin) data.amountBegin = this.form.amountBegin
            if(this.form.amountEnd) data.amountEnd = this.form.amountEnd
            if(this.form.jobNo) data.jobNo = this.form.jobNo
            if(this.form.noteType) data.noteType = this.form.noteType
            if(this.form.sendUserCode) data.sendUserCode = this.form.sendUserCode
            if(this.form.sendUserName) data.sendUserName = this.form.sendUserName
            if(this.form.tag) data.tag = this.form.tag
            if(this.form.title) data.title = this.form.title

            let res = await projectFundsList(data)
            this.listLoading = false
            if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }
            this.tableData = res.Data.datas
            this.total = res.Data.total
        },
        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()
        },
    }
  }
</script>

<style lang="scss">
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }
    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
    .project-payment {
        .selected {
            color: #409EFF;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }
</style>